import React from "react";

import { TypeToledo } from "@at/design-system-foundation";
import { AccordionItemPropsTypes, Banner } from "@at/design-system-patterns";

export function HowMuchDoesItCost(): AccordionItemPropsTypes[] {
  return [
    {
      rowHeading: "How much does it cost?",
      trackingLabel: "how-much-does-it-cost",
      rowContent: (
        <>
          <p>
            Public charging points are run by a variety of different companies
            and networks, which means pricing will vary. Public charging does
            typically cost more per hour than home charging, but some networks
            offer cheaper rates through monthly memberships.
          </p>
        </>
      ),
    },
  ];
}
export function HowLongDoesItTake(
  channelCopy: string,
  channelSingular: string,
): AccordionItemPropsTypes[] {
  return [
    {
      rowHeading: "How long does it take?",
      trackingLabel: "how-long-does-it-take",
      rowContent: (
        <>
          <p>
            Different public charging points offer a range of different charging
            speeds. You can use map tools to locate your nearest charging points
            and filter by charging speed.
          </p>
          <TypeToledo as="h3" weight="500">
            Ultra rapid
          </TypeToledo>
          <p>
            An ultra rapid charger is up to 50 times more powerful than a
            typical installed home charge point.
          </p>
          <p>
            These chargers are usually found at motorway services, fast food
            outlets, coffee shops and new charging &apos;hubs&apos;.
          </p>
          <p>
            These chargers can add over 120 miles of driving range in 10 minutes
            on some of the latest vehicles.
          </p>
          <p>
            On average most newer vehicles capable of taking ultra rapid
            charging speeds will charge to 80% in around 20 to 35 minutes at an
            ultra rapid charge point.
          </p>
          <Banner variation={"info"} type={"in-panel"}>
            Ultra rapid charging speed is greatly affected by battery
            temperature, so charging times may be much longer in winter.
          </Banner>

          <TypeToledo as="h3" weight="500">
            Rapid
          </TypeToledo>

          <p>
            A rapid charger is up to 7 times more powerful than a typical 7.4kW
            home charge point.
          </p>
          <p>
            These chargers are usually found at places like pubs, supermarkets
            and public car parks.
          </p>
          <p>
            On average most newer electric vehicles will charge to 80% in around
            45 minutes to 1 hour 15 minutes using these chargers.
          </p>
          <TypeToledo as="h3" weight="500">
            Fast
          </TypeToledo>
          <p>
            Fast chargers can deliver either a 7kW or a 22kW charging speed.
            They are a good option if you have no access to home charging, or if
            you&apos;re leaving your {channelSingular} for a few hours. For
            example, in a car park near work.
          </p>
          <p>
            You can usually find fast charging points in most public car parks
            and supermarkets, and they usually take 6 to 7 hours to fully charge
            most electric {channelCopy}.
          </p>
        </>
      ),
    },
  ];
}
